module.exports = __webpack_public_path__ + "img/error.858f3cdf.png";